import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Auth/comprobarEntorno`, method: 'GET', body: null, token: token})
}
